/** Message shown in window.confirm when leaving the profile wizard (set from PlayerProfilePage). */
let leaveConfirmMessage = '';

export function setIncompleteProfileLeaveMessage(message) {
  leaveConfirmMessage = typeof message === 'string' && message.trim() ? message.trim() : '';
}

export function clearIncompleteProfileLeaveMessage() {
  leaveConfirmMessage = '';
}

export function confirmLeaveIncompleteProfile() {
  if (!leaveConfirmMessage) return true;
  return window.confirm(leaveConfirmMessage);
}

/** @param {unknown} to react-router `to` (string or object) */
export function stringifyRouterTo(to) {
  if (typeof to === 'string') return to;
  if (to && typeof to === 'object' && typeof to.pathname === 'string') {
    return `${to.pathname}${to.search || ''}`;
  }
  return '';
}

/**
 * Player is on the profile form with incomplete account — leaving to another route should confirm first.
 */
export function tryNavigateFromProfileWizard(user, pathname, nextTo) {
  const dest = stringifyRouterTo(nextTo).split('?')[0];
  if (user?.type !== 'player' || user.profileComplete !== false) return true;
  if (!pathname.startsWith('/player/settings/profile')) return true;
  if (dest === '/player/settings/profile' || dest.startsWith('/player/settings/profile/')) return true;
  return confirmLeaveIncompleteProfile();
}
